/*------------------------------------------------------------------
Internal imports
------------------------------------------------------------------*/

import { $, $$, debounce } from '@/utilities/helpers';

/*------------------------------------------------------------------
Elements
------------------------------------------------------------------*/

let isSyncingFromPopstate = false;
let changeSearchTypeHasChanged = false;
let $loadMoreResults = $('.js-load-more-search-results');
let $searchFilters = $$('.js-filter-search-results');
let $siteSearchInput = $('#site-search');
let $searchResults = $('.js-search-no-results');


let controller = new AbortController();
let signal = controller.signal;

let current_page = undefined;


/**
 * Render the fetched results into the results container
 * @param {object} data - The data returned from the API
 * @returns {void}
 */
const renderResults = ({ data = {}, message }) => {

    let html = '';

    if (data.results && data.results.length) {
        $('.search__actions').style.display = 'flex';
        $('.search__count').textContent = `${data.total} result${data.total !== 1 ? 's' : ''}`;
        current_page = data.current_page;
        data.results.forEach(item => html += item);
    } else {
        $('.search__actions').style.display = 'none';
        $('.search__count').textContent = '0 results';
        current_page = undefined;
        html = /*html*/`<p class="text-center colour--grey-mid no-results-message" style="max-width: 40rem;">${message || 'Sorry, there are no results for your search.'}</p>`;
    }

    $loadMoreResults.parentNode.style.display = (data.has_more) ? 'block' : 'none';

    if (current_page && current_page > 1) {
        $searchResults.insertAdjacentHTML('beforeend', html);
    } else {
        $searchResults.innerHTML = html;
    }


}


/**
 * Site search function
 * @returns {void}
 */
function search() {

    // Abort any ongoing fetch request if there is no query
    if (!$siteSearchInput?.value) {
        renderResults({ data: {}, message: `Enter in your search terms above to search <br>Smart Investor.` });
        return
    };

    if (isSyncingFromPopstate) return;

    let apiUrl = $searchResults?.dataset.apiUrl;

    if (!apiUrl) return;

    let url = new URL(apiUrl, window.location.origin);
    let params = new URLSearchParams(window.location.search);
    url.search = params.toString();

    if (current_page === undefined) document.body.classList.add('search-busy');

    fetch(url.toString(), { signal })
        .then(response => response.json())
        .then(data => {
            document.body.classList.add('fetched');
            setTimeout(() => document.body.classList.remove('search-busy'), 500);
            renderResults({ data });
        })
        .catch(error => {
            (error.name === 'AbortError') ? console.log('Search aborted') : console.error('Error:', error)
            setTimeout(() => document.body.classList.remove('search-busy'), 500);
            renderResults({ message: 'An error occurred while fetching results. Please try refreshing your browser.' });
        })
        .finally(() => {

        });


}


if ($loadMoreResults) {
    $loadMoreResults.addEventListener('click', (e) => {
        e.preventDefault();

        // Load more results here
        $loadMoreResults.innerHTML = '<div class="load-more__spinner spinner"></div><b>Loading...</b>';

        current_page = current_page ? current_page + 1 : 2;

        updateURL();

        setTimeout(() => {
            $loadMoreResults.innerHTML = '<b>Load 10 more results</b>';
        }, 2000);
    });
}


$searchFilters.forEach($toggle => {
    $toggle.addEventListener('click', (e) => {
        changeSearchTypeHasChanged = true;
        updateURL();
    });
});

/**
 * Update the URL with current filters
 * @returns {void}
 */
function updateURL(c = true) {
    let url = '?';

    // Keyword [<value>]
    let keyword = $siteSearchInput ? $siteSearchInput.value : undefined;
    if (keyword) url += `keyword=${encodeURIComponent(keyword)}&`;

    // Array of providers
    let searchFilters = $('.js-filter-search-results:checked') ? [...$$('.js-filter-search-results:checked')].map(o => o.value) : [];
    if (searchFilters.length) searchFilters.forEach(provider => url += `searchFilters[]=${provider}&`);

    // Offset
    if (current_page) url += `page=${current_page}&`;

    // if the last character of the url is '?' or '&', remove it
    if (url.slice(-1) === '?' || url.slice(-1) === '&') url = url.slice(0, -1);

    // Update the history
    history.pushState(null, '', `${window.location.origin}${window.location.pathname}${url}`);

    // Fetch the results
    search();

}


/**
 * Update search input values
 * @param {string} filter 
 * @param {string} value 
 * @param {boolean} skipHistory 
 */
function updateInputs(filter, value, skipHistory = false) {

    if (filter === 'keyword') {
        $siteSearchInput.value = value;
    } else if (filter === 'searchFilters') {
        $searchFilters.forEach($toggle => {
            $toggle.checked = (value.includes($toggle.value))
        });
    }

    if (!skipHistory) updateURL();

}

/**
 * Load filters from URL
 * @returns {void}
 */
function loadFiltersFromURL() {

    let filters = new URLSearchParams(window.location.search);

    // Set flag to prevent history update
    isSyncingFromPopstate = true;

    // Keyword [<value>]
    if (filters.has('keyword')) updateInputs('keyword', filters.get('keyword'), true);

    // Fund type [defensive, conservative, balanced, growth, aggressive]
    if (filters.has('searchFilters[]')) updateInputs('searchFilters', filters.getAll('searchFilters[]'), true);

    // Unset flag after UI sync
    isSyncingFromPopstate = false;

}

$siteSearchInput?.addEventListener('keydown', debounce((e) => {
    changeSearchTypeHasChanged = true;
    if ($siteSearchInput.value.length >= 3) {
        let shoudSearch = false;
        updateURL(shoudSearch = false);
    } else {
        updateURL();
    }
}, 800));

if ($siteSearchInput) {

    // On url change
    window.addEventListener('popstate', loadFiltersFromURL);

    loadFiltersFromURL();

    search();
}